var render = function render(){var _vm=this,_c=_vm._self._c;return (true)?_c('div',{staticClass:"queued-report-info w-100 border-radius--light shadow-sm",class:_vm.reportStatus.status},[_c('i',{class:`fas ${_vm.reportStatus.icon} font-20`}),_c('span',{staticClass:"ml-3",domProps:{"innerHTML":_vm._s(_vm.renderMessage)},on:{"click":_vm.handleClick}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }